import { GeoClass } from '../interface/response/GeoFiltersResponse';
/**
 * Resolves whether the payment type column should be visible.
 *
 * The payment type column is displayed only when
 * at least one payment type is selected.
 *
 * @param params - Visibility configuration
 * @param params.selectedPaymentTypes - List of selected payment types
 *
 * @returns Object containing payment type visibility state
 * - `showPaymentType` - Indicates whether the payment type column should be shown
 */

interface ResolvePaymentTypeVisibilityParams {
  selectedPaymentTypes: GeoClass[];
}

interface ResolvePaymentTypeVisibilityResult {
  showPaymentType: boolean;
}

export const resolvePaymentTypeVisibility = ({
  selectedPaymentTypes,
}: ResolvePaymentTypeVisibilityParams): ResolvePaymentTypeVisibilityResult => {
  return {
    showPaymentType: selectedPaymentTypes.length > 0,
  };
};
